module.exports = __webpack_public_path__ + "static/media/Step2.68a56a4a.png";